export default __webpack_public_path__ + "static/media/Rubbish - Coral.e66353e0.svg";